module.exports = "/packs/icon-progress-7dbb10b61de472a560b948bb59d82751.png";